define('lib/Podio.UI.Presence',['require','jquery','lib/Podio.Router','lib/Podio.Event.UI','lib/Podio.Config','lib/Podio.UI.Tooltips'],function(require) {

  var $ = require('jquery');
  var router = require('lib/Podio.Router');
  var eventUI = require('lib/Podio.Event.UI');
  var podioConfig = require('lib/Podio.Config');
  var tooltips = require('lib/Podio.UI.Tooltips');

  function onPresenceAvatarClicked(elmTarget, e) {
    var elmPresence = elmTarget.parents('li.presence-item');
    var elmPresenceActions = elmPresence.find('.presence-actions');
    if (elmPresenceActions.is(':visible')) {
      elmPresence.parent().find('.presence-actions').hide();
      elmPresence.parent().find('li.presence-item').unbind('outsideclick');
    }
    else {
      elmPresence.parent().find('.presence-actions').hide();
      elmPresenceActions.show();
      tooltips.hideAll();

      elmPresence.bind( "outsideclick", onOutsideClick.curry(elmPresence));
    }
  }

  function onOutsideClick(elmPresence, e) {
    if( ($(e.target).is('li.presence-item')) || ($(e.target).parents('li.presence-item').length)) {
      return;
    }
    $('.presence-list-box .presence-actions').hide();
    elmPresence.unbind('outsideclick');
  }

  function onInviteClick(elmTarget, e) {
    var space_id = elmTarget.data('space-id') || podioConfig.space_id;
    router.goToHashRoute('invite/{0}'.format(space_id));
  }

  eventUI.bind('click', '.presence-item a.presence-actions-trigger', onPresenceAvatarClicked);
  eventUI.bind('click', '.presence-list-box .invite-link', onInviteClick);

});

